<template>
    <div :class="['parametric-card', {'is-booked': flat.isBooked, 'is-hovered': cardHovered}]"
         @click="redirectLeft(flat.link, flat.id)"
         @mouseenter="hoverCard"
         @mouseleave="cardHovered = false">
        <div class="parametric-card__content">
            <div class="parametric-card__top">
                <p class="parametric-card__area parametric-results__loader">
                    {{ flat.area }} м<sup>2</sup>
                </p>
                <p class="parametric-card__title parametric-results__loader">
                    {{ flat.title }}
                </p>
            </div>
            <div class="parametric-card__params">
                <p v-if="flat.deadlineText" class="parametric-card__params-param parametric-results__loader">
                    {{ flat.deadlineText }}
                </p>
                <p v-if="isEstateFlat && flat.floor"
                    class="parametric-card__params-param parametric-results__loader">
                    Этаж {{ flat.floor }} из {{ flat.floorsTotal }}
                </p>

                <button type="button"
                    :class="['parametric-results__favorite', 'j-favorite-btn', {'is-active': checkFavorite(flat.id)}]"
                    :data-id="flat.id"
                >
                    <FavoriteIcon />
                </button>

            </div>

            <div class="parametric-card__plan">
                <img :src="flat.plan" :alt="flat.title">

                <transition name="fade-default">
                    <button
                        v-if="isMobile || (cardHovered && flat.plan)"
                        class="button parametric-card__plan-zoom j-zoom"
                        ref="zoom"
                        @click.prevent="zoom">
                        <ZoomIcon />
                    </button>
                </transition>
            </div>

            <div class="parametric-card__price">
                <div v-if="flat.isBooked" class="parametric-card__state parametric-results__loader">Забронировано</div>

                <div v-if="!flat.isBooked" class="parametric-card__prices">
                    <div class="parametric-results__loader">
                        {{ Number(flat.price) ? `${convertToDigit(flat.price)} ₽` : flat.price }}
                    </div>

                    <div v-if="flat.priceOld" class="parametric-card__price-old parametric-results__loader">
                        {{ Number(flat.priceOld) ? `${convertToDigit(flat.priceOld)} ₽` : flat.priceOld }}
                    </div>
                </div>

                <div v-if="flat.options && flat.options.length"
                     class="parametric-card__options j-parametric-card-options">
                    <div class="parametric-card__options-item">
                        {{ flat.options[0].name }}
                    </div>
                    <button
                        class="parametric-card__options-more
                        j-parametric-card-options-more"
                        @click="clickOnMobile"
                        @mouseenter="showTooltip()"
                        @mouseleave="hideTooltip">
                        <MoreIcon />
                    </button>
                    <transition name="fade">
                        <OptionsList
                            v-if="flat.options.length > 1"
                            :options="flat.options.slice(1, flat.options.length)"
                            :isOpen="optionsIsOpen" />
                    </transition>
                </div>
            </div>
        </div>
        <div class="parametric-card__booked" v-if="flat.isBooked">
            <BookedIcon />
        </div>
    </div>
</template>

<script>
import BookedIcon from '../../svg-media/BookedIcon.vue';
import {convertToDigit} from '../../mixins.js';
import FavoriteIcon from '../../svg-media/favorite.vue';
import {mapGetters} from 'vuex';
import MoreIcon from '../../svg-media/more.vue';
import Observer from 'common/scripts/observer';
import OptionsList from '../OptionsList/OptionsList.vue';
import Utils from 'common/scripts/utils';
import ZoomIcon from '../../svg-media/ZoomIcon.vue';

const observer = new Observer();

export default {
    props: ['flat'],

    components: {
        BookedIcon,
        FavoriteIcon,
        MoreIcon,
        OptionsList,
        ZoomIcon
    },

    data() {
        return {
            optionsIsOpen: false,
            moreClass    : 'j-parametric-card-options-more',
            tooltipDelay : false,
            cardHovered  : false
        };
    },

    computed: {
        ...mapGetters({
            estateType: 'GET_ESTATETYPE',
            isMobile  : 'GET_IS_MOBILE'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },

    mixins: [convertToDigit],

    mounted() {
        this.bindEvents();
    },

    beforeDestroy() {
        this.unBindEvents();
    },

    methods: {
        bindEvents() {
            window.addEventListener('scroll', this.hideTooltip.bind(this));
        },

        unBindEvents() {
            window.removeEventListener('scroll', this.hideTooltip.bind(this));
        },

        checkFavorite(id) {
            const cookies = Utils.getCookie('fav_f');

            return Boolean(cookies && cookies.includes(id));
        },

        redirectLeft(link, id) {
            const selector = `.j-favorite-btn[data-id="${id}"]`;
            const buttons = Array.from(document.querySelectorAll(selector));
            const element = event.target;

            if (element.classList.contains('j-favorite-btn') ||
                element.classList.contains('j-favorite-btn-svg') ||
                element.parentElement.classList.contains('j-favorite-btn-svg')) {
                observer.publish('favorite-parametric', id);

                buttons.forEach((item) => {
                    item.classList.toggle('is-active');
                });
            } else if (!element.classList.contains(this.moreClass) &&
                       !element.parentElement.classList.contains(this.moreClass) &&
                       element !== this.$refs.zoom &&
                       !element.closest('.j-zoom')) {
                window.location = link;
            }
        },

        showTooltip() {
            if (this.optionsIsOpen || this.tooltipDelay) {
                return;
            }

            setTimeout(() => {
                this.optionsIsOpen = true;
            }, 100);
        },

        zoom() {
            this.$root.$emit('zoom', this.flat);
        },

        hideTooltip() {
            if (!this.optionsIsOpen) {
                return;
            }

            this.optionsIsOpen = false;
        },

        hoverCard(event) {
            if (!event.target.classList.contains(this.moreClass) &&
                !event.target.parentElement.classList.contains(this.moreClass)) {
                this.optionsIsOpen = false;
            }

            this.cardHovered = true;
        },

        clickOnMobile() {
            if (this.isMobile) {
                this.optionsIsOpen = !this.optionsIsOpen;
            }
        }
    }
};
</script>
